import { createContext, useContext, useEffect, useState } from "react";
import { socket } from "../config/socket.io";

const WalletContext = createContext();

export function WalletProvider({ children }) {
  const [wallet, setWallet] = useState(null);

  // Centralized socket updates for wallet and spin status
  useEffect(() => {
    const handleWalletUpdate = (data) => {
      if (!data) return;
      setWallet(prev => {
        const hasSpin = data.hasSpin !== undefined ? data.hasSpin : prev?.hasSpin;
        const updated = {
          ...prev,
          ...data,
          hasSpin,
        };
        if (hasSpin) {
          updated.spin_and_win = {
            ...(prev?.spin_and_win || {}),
            hasSpin,
          };
        }
        return updated;
      });
    };

    const handleClearLucky = () => {
      setWallet((prev) => {
        if (!prev) return prev;
        return {
          ...prev,
          binary: {
            ...(prev.binary || {}),
            activeMultiplier: 0,
          },
        };
      });
    };

    socket.on("wallet_update", handleWalletUpdate);
    socket.on("walletUpdate", handleWalletUpdate);
    window.addEventListener("clear-lucky-multiplier", handleClearLucky);

    return () => {
      socket.off("wallet_update", handleWalletUpdate);
      socket.off("walletUpdate", handleWalletUpdate);
      window.removeEventListener("clear-lucky-multiplier", handleClearLucky);
    };
  }, []);

  return (
    <WalletContext.Provider value={{ wallet, setWallet }}>
      {children}
    </WalletContext.Provider>
  );
}

// custom hook
export function useWallet() {
  return useContext(WalletContext);
}
